module.exports = __webpack_public_path__ + "media/images/doctor_profiles/default/ng-image__6-b74eb7051bf46abc999610d7090fbf43.png";